import React, { memo, useState, useRef, useEffect } from "react";
import dot_green from "../img/dot_green.png";
import dot_red from "../img/dot_red.png";
import dot_yellow from "../img/dot_yellow.png";





export default memo((props) => {
  const { value, onValueChange, cellEditorParams } = props;

  const [isOpen, setIsOpen] = useState(false);
  const refContainer = useRef(null);


  const users = props?.colDef?.cellEditorParams?.users;
  const userOptions = {}
  users.forEach((element) => {
    userOptions[element.id] = element.first_name+" "+element.last_name
  })

  //it works until here for sure

  useEffect(() => {
    function handleClickOutside(event) {
      if (refContainer.current && !refContainer.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const onClick = (newValue) => {
    //this also seem to work

    onValueChange(parseInt(newValue,10));
    setIsOpen(false);
  };

  const boxStyle = {
    position: "relative",
    borderRadius: 5,
    border: "1px solid grey",
    backgroundColor: "#ffffff",
    padding: 10,
    textAlign: "center",
    height: "40px",
    display: "inline-flex",
    alignItems: "center",
    cursor: "pointer",
  };

  const dropdownStyle = {
    position: "absolute",
    top: "100%",
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    border: "1px solid grey",
    borderRadius: 10,
    padding: 10,
    display: isOpen ? "flex" : "none",
    flexDirection:"column",
    justifyContent: "center",
    gap: 10,
  };

  return (
    <div ref={refContainer} style={{ position: "relative", display: "inline-block" }}>
      <div style={boxStyle} onClick={() => setIsOpen((prev) => !prev)}>
        {userOptions[value]}
        <span style={{ position:"absolute", marginLeft: 130, fontSize: "20px" }}>▼</span>
      </div>
      <div style={dropdownStyle}>
        {Object.entries(userOptions).map(([key, e]) => (
          <div key={key} onClick={() => onClick(key)}>
            {e}
          </div>
        ))}
      </div>
    </div>
  );
});
